import { AxiosError, ResponseType } from 'axios'
import { Action } from 'redux'

import { VoidCallback } from '@/travelsuit/callback'
import { ApiError } from '@/types/error/ErrorResponse'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface IAction<Payload = any, RequestPayload = Payload, CallbackResponse = any> extends Action {
	type: string
	payload?: Payload
	requestPayload?: RequestPayload
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	requestParams?: any
	responseType?: ResponseType
	callback?: VoidCallback<CallbackResponse>
	errCallback?: VoidCallback<AxiosError<ApiError>>
	abortControllerCallback?: VoidCallback<AbortController>
	swapCallbackAndSuccessAction?: boolean
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	body?: any
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	params?: any
	polling?: { jobId: string }
}

export type RequestTypeMapping = Record<
	'ORIGINAL' | 'REQUEST' | 'UPDATE' | 'SUCCESS' | 'FAILED' | 'REQUEST_JOB' | 'REQUEST_JOB_RESULT',
	string
>

export function RequestTypeAction(name: string, prefix?: string): RequestTypeMapping {
	const original = `${prefix ? prefix + '/' : ''}${name}`
	return {
		ORIGINAL: original,
		REQUEST: `${original}_REQUEST`,
		UPDATE: `${original}_UPDATE`,
		SUCCESS: `${original}_SUCCESS`,
		FAILED: `${original}_FAILED`,
		REQUEST_JOB: `${original}_REQUEST_JOB`,
		REQUEST_JOB_RESULT: `${original}_REQUEST_JOB_RESULT`,
	}
}
/** @deprecated Only for the old Redux requests. In the new code use `src/types/job` */
// eslint-disable-next-line no-restricted-syntax
export enum PollingStatus {
	Sent = 'sent',
	InProgress = 'in progress',
	Success = 'success',
	Expired = 'expired',
	Failed = 'failed',
	Completed = 'completed',
}

export function isRequestTypeAction(object: unknown): object is RequestTypeMapping {
	return Object.getOwnPropertyNames(object).includes('ORIGINAL')
}

export function RequestTypeActionMap<T extends string>(keys: T[], prefix?: string): Record<T, RequestTypeMapping> {
	return keys.reduce(
		(all, k) => Object.assign(all, { [k]: RequestTypeAction(k, prefix) }),
		{} as Record<T, RequestTypeMapping>,
	)
}

export function ActionMap<T extends string>(keys: T[], prefix?: string): Record<T, string> {
	return keys.reduce(
		(all, k) => Object.assign(all, { [k]: [prefix, k].filter(Boolean).join('/') }),
		{} as Record<T, string>,
	)
}

export function isFailedAction<Payload>(action: IAction): action is IAction<Payload> {
	return action.type.endsWith('_FAILED')
}
